import { getLocalAccessToken } from "../../utils/helper";
import api, { handleErrorCreateAndUpdate } from "../../services/api";
import { Toast } from "../../components/notify/Notify";
import { url } from "../../constants/path";
const accessToken = getLocalAccessToken();

api.defaults.headers.common["Authorization"] = "Bearer " + accessToken;

const URL = url.systemRole;

export const createRole = (data, callback) => {
  api
    .post(URL, data)
    .then((response) => {
      getDetailRole(response.data.data.id, (result) => {
        callback(result);
        Toast("success", "Thành công");
      });
    })
    .catch((err) => {
      handleErrorCreateAndUpdate(err, callback);
    });
};

export const updateRole = (id, data, callback) => {
  api
    .patch(`${URL}/${id}`, data)
    .then((response) => {
      callback(response);
      Toast("success", "Successful");
    })
    .catch((err) => {
      handleErrorCreateAndUpdate(err, callback);
    });
};

export const deleteRole = (id) => {
  api
    .delete(`${URL}/${id}`)
    .then((response) => Toast("success", "Thành công"))
    .catch((err) => {
      Toast("warning", err.response.data.message);
    });
};

export const getRoles = (params = {}, callback) => {
  api
    .get(URL, { params })
    .then((response) => callback(response.data.data))
    .catch((err) => {
      Toast("warning", err.response.data.message);
    });
};

export const getDetailRole = (id, callback) => {
  api.get(`${URL}/${id}`).then((response) => callback(response.data.data));
};
